export const GET_PLANS_SUCCESS = "GET_PLANS_SUCCESS";
export const VERIFY_COUPON_CODE_SUCCESS = "VERIFY_COUPON_CODE_SUCCESS";
export const RESET_COUPON_CODE = "RESET_COUPON_CODE";
export const PLAN_SUBSCRIBE = "PLAN_SUBSCRIBE";
export const REDEEM_SUCCESS = "REDEEM_SUCCESS";
export const RESET_REDEEM_STATUS = "RESET_REDEEM_STATUS";